import { NavLink, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { BrandLogo } from "@/components/layout/BrandLogo";
import { AppSidebarTrigger } from "@/components/layout/AppSidebarTrigger";
import { QuantumFoundryMark } from "@/components/layout/QuantumFoundryMark";
import { APP_VERSION, APP_VERSION_LABEL } from "@/lib/appMeta";
import { getVisibleNavGroups } from "@/lib/navConfig";
import { useHasPermission } from "@/features/auth/useAuth";
import { cn } from "@/lib/utils";

export function AppSidebar() {
  const location = useLocation();
  const { state } = useSidebar();
  const expanded = state === "expanded";
  const can = useHasPermission();
  const navGroups = getVisibleNavGroups(can);

  return (
    <Sidebar collapsible="icon" variant="sidebar" className="sidebar-animated shadow-none">
      <SidebarHeader className="sidebar-masthead">
        <div className="flex w-full items-center justify-between gap-1.5 group-data-[collapsible=icon]:flex-col group-data-[collapsible=icon]:justify-center">
          <BrandLogo showText={expanded} />
          <AppSidebarTrigger />
        </div>
      </SidebarHeader>

      <SidebarContent className="sidebar-nav" role="navigation" aria-label="Main">
        {navGroups.map((group) => (
          <SidebarGroup key={group.id} className="px-0 py-1.5">
            <SidebarGroupLabel className="sidebar-section-label">
              {group.label}
            </SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu className="gap-px">
                {group.items.map((item) => {
                  const Icon = item.icon;
                  const isActive = location.pathname === item.to;
                  return (
                    <SidebarMenuItem key={item.to}>
                      <SidebarMenuButton
                        isActive={isActive}
                        tooltip={item.label}
                        render={<NavLink to={item.to} />}
                        className={cn(
                          "h-8 px-2.5 text-sm text-muted-foreground",
                          isActive && "nav-item-active",
                        )}
                      >
                        <Icon className="size-4" strokeWidth={1.75} />
                        <span>{item.label}</span>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  );
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>

      <SidebarFooter className="sidebar-credit flex-row items-center">
        <QuantumFoundryMark compact={!expanded} />
        {expanded && (
          <p className="sidebar-version" title={`Version ${APP_VERSION}`}>
            {APP_VERSION_LABEL}
          </p>
        )}
      </SidebarFooter>
    </Sidebar>
  );
}
